export default __webpack_public_path__ + "static/media/error.96841b05.svg";